export default __webpack_public_path__ + "static/media/blog-img75.fb3784f3.jpg";